export function createPageUrl(siteUrl, page) {
  var pageType = page.pageType,
    slug = page.slug,
    url = page.url;
  if (pageType === 'External' && url) {
    return url;
  }
  if (!siteUrl) {
    return '';
  }
  if (!slug) {
    return siteUrl;
  }
  var normalizedSiteUrl = siteUrl.endsWith('/') ? siteUrl.slice(0, -1) : siteUrl;
  var normalizedSlug = slug.startsWith('/') ? slug : "/".concat(slug);
  return "".concat(normalizedSiteUrl).concat(normalizedSlug);
}
export function createNavigationSchema(pages, siteUrl, navigationElementId) {
  return {
    '@context': 'https://schema.org',
    '@graph': pages.map(function (page) {
      var _page$title = page.title,
        title = _page$title === void 0 ? '' : _page$title;
      return {
        '@context': 'https://schema.org',
        '@type': 'SiteNavigationElement',
        '@id': navigationElementId,
        name: title,
        url: createPageUrl(siteUrl, page)
      };
    })
  };
}